// extracted by mini-css-extract-plugin
export var root = "F_th";
export var wrapper = "F_sX";
export var image = "F_tj d_s d_v d_S";
export var crop = "F_tk";
export var round = "F_tl";
export var fixedHeight = "F_tm";